import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchDashBoard } from "./service/service";
import { bindActionCreators } from "redux";
import { getDashboards } from "./reducer/reducer";
import Pc from "../../common/breakpoints/Pc";
import Sp from "../../common/breakpoints/Sp";
import DashboardBuilder from "./DashboardBuilder";
import DashboardBuilderSP from "./DashboardBuilderSP";
import DrawingDialog from "components/DrawingDialog";
import { FETCH_DASHBOARDS_SUCCESS } from "./constant/constant";
import { MODE_DEVICE } from "components/sites/site/LogWalkViewer/constants";

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      isShowDialogDrawing: false,
      sitesUC: null,
      fetching: true,
      redirectFromUrl: null
    };
  }

  componentWillMount() {
    const { state } = this.props.history.location;
    if (this.props.redirectFromUrl.isRedirectFromUrl) {
      this.setState({ redirectFromUrl: this.props.redirectFromUrl });
    }

    this.props.fetchDashBoard();
    if (state && state.reload) {
      state.reload = false;
    }
  }

  componentWillReceiveProps(props) {
    const { state } = props.history.location;
    if (state && state.reload) {
      this.props.fetchDashBoard();
      state.reload = false;
    }
    if (props.type === FETCH_DASHBOARDS_SUCCESS) {
      this.setState({ fetching: false });
    }
  }

  to = id => () => {
    this.props.history.push("/sites/" + id);
  };

  showHideDialogDrawing = (sitesUC = null) => {
    this.setState({
      isShowDialogDrawing: !this.state.isShowDialogDrawing,
      sitesUC
    });
  };

  render() {
    const { dashboards } = this.props;
    const { fetching, isShowDialogDrawing, sitesUC, redirectFromUrl } =
      this.state;

    return fetching ? (
      <></>
    ) : (
      <>
        <Sp>
          <DashboardBuilderSP
            dashboards={dashboards}
            to={this.to}
            showDialogDrawing={this.showHideDialogDrawing}
          />
        </Sp>
        <Pc>
          <DashboardBuilder
            dashboards={dashboards}
            to={this.to}
            showDialogDrawing={this.showHideDialogDrawing}
            redirectFromUrl={redirectFromUrl}
          />
        </Pc>
        {isShowDialogDrawing && (
          <Pc>
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.PC}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
            />
          </Pc>
          // <DrawingDialog
          //   open={isShowDialogDrawing}
          //   onClose={this.showHideDialogDrawing}
          //   sitesUC={sitesUC}
          // />
        )}
        {isShowDialogDrawing && (
          <Sp>
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.SP}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
            />
          </Sp>
          // <DrawingDialog
          //   open={isShowDialogDrawing}
          //   onClose={this.showHideDialogDrawing}
          //   sitesUC={sitesUC}
          // />
        )}
      </>
    );
  }
}

Dashboard.propTypes = {
  fetchDashBoard: PropTypes.func.isRequired,
  dashboards: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  dashboards: getDashboards(state.dashboardsReducer.dashboard),
  type: state.rootSitesReducer.siteInfoReducer.type,
  redirectFromUrl: state.rootSitesReducer.siteInfoReducer.redirectFromUrl
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchDashBoard: fetchDashBoard
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
